import { defineMessages } from 'react-intl';

type MessageKeys = 'noKnowledgeAdded' | 'allKnowledgeAdded' | 'forgeKnowledgeDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noKnowledgeAdded: {
			id: 'rovo-chat.view-agent.no-knowledge-added',
			defaultMessage: 'No organizational knowledge',
			description: 'Message displayed when no knowledge is added to the agent',
		},
		allKnowledgeAdded: {
			id: 'rovo-chat.view-agent.all-knowledge-added',
			defaultMessage: 'All organizational knowledge',
			description: 'Message displayed when all organizational knowledge is added to the agent',
		},
		forgeKnowledgeDescription: {
			id: 'rovo-chat.view-agent.hidden-knowledge-description',
			defaultMessage: "Forge agents built with code don't use typical knowledge sources",
			description:
				'Description of the knowledge section, this is displayed when knowledge is purposely hidden',
		},
	});

export default message;
